import { render, staticRenderFns } from "./AndroidFirefox.vue?vue&type=template&id=7973fc32&scoped=true&"
var script = {}
import style0 from "./AndroidFirefox.vue?vue&type=style&index=0&id=7973fc32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7973fc32",
  null
  
)

export default component.exports